// eslint-disable-next-line import/prefer-default-export,no-multi-str
export const retinaMediaQuery = '\
  (-webkit-min-device-pixel-ratio: 1.5),\
  (min--moz-device-pixel-ratio: 1.5),\
  (-o-min-device-pixel-ratio: 3/2),\
  (min-resolution: 1.5dppx)\
';
